(() => {
  if (window.dmrStoryInitialized) return;
  window.dmrStoryInitialized = true;
  const films = () => document.querySelectorAll('[data-dmr-story-film]');
  const setup = film => {
    if (film.dataset.dmrStoryReady) return;
    film.dataset.dmrStoryReady = 'true';
    const video = film.querySelector('video');
    if (!video) return;
    const start = Number(film.dataset.dmrStoryStart || 0);
    video.muted = true;
    video.setAttribute('muted', '');
    video.playsInline = true;
    video.loop = true;
    if (start > 0) {
      const seek = () => { if (video.currentTime < start) video.currentTime = start; };
      video.addEventListener('loadedmetadata', seek);
      video.addEventListener('timeupdate', () => { if (video.duration && video.currentTime >= video.duration - 0.25) video.currentTime = start; });
      if (video.readyState >= 1) seek();
    }
    const sound = film.querySelector('[data-dmr-story-sound]');
    if (sound) sound.addEventListener('click', () => {
      const on = video.muted;
      video.muted = !on;
      sound.setAttribute('aria-pressed', String(on));
      if (on) video.play().catch(() => {});
    });
    const watcher = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) video.play().catch(() => {}); else video.pause();
    }), { threshold: 0.3 });
    watcher.observe(film);
  };
  const initialise = () => films().forEach(setup);
  document.addEventListener('shopify:section:load', initialise);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true }); else initialise();
})();
